import { getTransactionCsv, SuccessResponse } from '@back-office/http';
import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* getTransactionCSVRequest(
  self: Self,
  from: string,
  to: string
): Generator<Promise<AxiosResponse<Blob>>> {
  self.isLoading = true;
  try {
    const response = yield getTransactionCsv(from, to);
    if ((response as AxiosResponse<Blob>).status === 200) {
      const blob = new Blob([(response as AxiosResponse<Blob>)?.data], {
        type: 'text/csv;charset=utf-8',
      });
      saveAs(blob, 'transactions.csv');
      return Promise.resolve(ResponseMessage.OK);
    }
    if ((response as AxiosResponse<Blob>).status === 401) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default getTransactionCSVRequest;
